import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsOptional, IsString, IsUUID, MinLength, ValidateIf } from "class-validator";

@Exclude()
export class BaseAddress {
    @IsString()
    @MinLength(1, {
        message: "Address Line 1 should not be empty",
    })
    @IsDefined()
    @Expose()
    public addressLine1: string;

    @IsString()
    @IsOptional()
    @Expose()
    public addressLine2: string;

    @IsString()
    @MinLength(1, {
        message: "City should not be empty",
    })
    @IsDefined()
    @Expose()
    public city: string;

    @IsString()
    @IsDefined()
    @Expose()
    public region: string;

    @IsString()
    @MinLength(1, {
        message: "Postal Code should not be empty",
    })
    @IsDefined()
    @Expose()
    public postalCode: string;
}

@Exclude()
export class Address extends BaseAddress {
    @IsUUID("4")
    @Expose()
    @IsOptional()
    public regionId?: string;

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public countryId: string;
}

@Exclude()
export class MangopayAddress extends BaseAddress {
    @ValidateIf((address: MangopayAddress) => ["US", "CA", "MX"].includes(address.countryISOCode))
    @IsString()
    @Expose()
    public region: string;

    @IsString()
    @IsDefined()
    @Expose()
    public countryISOCode: string;
}
